const approvalStatus = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

const approvalStatusText = {};
approvalStatusText[approvalStatus.PENDING] = 'Pending';
approvalStatusText[approvalStatus.APPROVED] = 'Approved';
approvalStatusText[approvalStatus.REJECTED] = 'Rejected';

const mdmDetails = {
  RATEMATRIX: 'Rate Matrix',
};

const updatedMdmDetails = {
  rate_matrix: 'Rate Matrix',
  user: 'User',
  surge_threshold: 'Surge Threshold',
  vehicle_excludes: 'Vehicle Excludes',
  material: 'Material',
  associate_material: 'Associate Material',
  user_associate_material_upload: 'Material User Association',
  detention: 'Detention',
  vehicle: 'Vehicle',
  purchase_order: 'Purchase Order',
  loading: 'Loading/Unloading'
};

const mdmUploadStatus = {
  UPLOAD_STARTED: 'Upload Started',
  UPLOAD_IN_PROGRESS: 'Upload in Progress',
  UPLOAD_COMPLETED: 'Upload Completed',
  VALIDATION_STARTED: 'Validation Started',
  VALIDATION_COMPLETED: 'Validation Completed',
  UPLOAD_DISCARDED: 'Upload Discarded',
  APPROVAL_PENDING: 'Approval Pending',
  APPROVAL_REJECTED: 'Approval Rejected',
  APPROVED: 'Approved',
  UPLOAD_FAILED: 'Upload Failed',
  UPLOAD_PARTIAL_FAILED: 'Upload Partially Failed',
};

const invalidCollectionTypesMapping = {
  material: 'MATERIAL',
  associate_material: 'ASSOCIATED_MATERIAL',
  user_associate_material_upload: 'USER_ASSOCIATE',
  transporter: 'Transporter',
  'user': 'USER',
  'rate_matrix': 'CONTRACT',
  detention: 'DETENTION',
  'materialcategory': 'MATERIAL_CATEGORY',
  'contract_tsd': 'CONTRACT_TSD_MAP',
  'vehicle': 'VEHICLE',
  'consignee': 'CONSIGNEE',
  'consignee_additional_details': 'CONSIGNEE_OTHER_INFO',
  'sla': 'SLACHARGES',
  'depot': 'DEPOTS',
  'gate': 'GATES',
  'extra_drop_off_charge': 'EXTRA_DROP_OFF_CHARGE',
  loading: 'LOADINGCHARGES',
  'dedicatedtruck': 'DEDICATED_TRUCK',
  driver: 'DRIVER',
  vehicledetail: 'VEHICLE_DETAIL',
  source_charge: 'SOURCE_CHARGE_MASTER',
  'purchase_order': 'PURCHASE_ORDER',
  bucc: 'BUCC',
  transit_management: 'TRANSITMANAGEMENT',
  material_category_additional: 'MATERIAL_CATEGORY_ADDITIONAL',
  redirection: 'REDIRECTION_MASTER',
  base_fuel_rate: 'BASE_FUEL_RATE',
  freight_zone: 'FREIGHT_ZONE_MASTER',
  legal_entity: 'LEGAL_ENTITY',
  consignee_secondary_user: 'CONSIGNEE_SECONDARY_USER',
};

const validDataClassMap = {
  'user': 'UsersMasterDbWrite',
  'surge_threshold': 'SurgeThresholdDbWrite',
  'vehicle_excludes': 'VehicleExcludesDbWrite',
  'rate_matrix': 'RateMatrixDbWrite',
  'detention': 'DetentionDbWrite',
  'materialcategory': 'MaterialCategoryDbWrite',
  'sla': 'SLAMasterDbWrite',
  'share_of_business': 'ContractTsdMasterDbWrite',
  'vehicle': 'VehicleDbWrite',
  'consignee': 'ConsigneesMasterDbWrite',
  'consignee_additional_details': 'ConsigneesAdditionalDetailsMasterDbWrite',
  'transporter': 'TransporterMasterDbWrite',
  depot: 'DepotMasterDbWrite',
  gate: 'GateDbWrite',
  material: 'MaterialMasterDbWrite',
  associate_material: 'MaterialAssociateDbWrite',
  extra_drop_off_charge: 'DropOffChargeDbWrite',
  material_user_association: 'MaterialUserAssociateDbWrite',
  loading: 'LoadingUnloadingMasterDbWrite',
  dedicatedtruck: 'DedicatedTruckDbWrite',
  user_associate_material_upload: 'MaterialUserAssociateDbWrite',
  driver: 'DriverMasterDbWrite',
  vehicledetail: 'VehicleDetailsDbWrite',
  vehicle_availability: 'VehicleAvailabilityDbWrite',
  source_charge: 'SourceChargeDbWrite',
  purchase_order: 'PurchaseOrderDbWrite',
  bucc: 'BuccMasterDbWrite',
  transit_management: 'TransitManagementDbWrite',
  material_category_additional: 'MaterialCategoryAdditionalDbWrite',
  redirection: 'RedirectionMasterDbWrite',
  base_fuel_rate: 'BaseFuelRateMasterDbWrite',
  freight_zone: 'FreightZoneMasterDbWrite',
  legal_entity: 'LegalEntityDbWrite',
  vehicle_eta: 'VehicleETADbWrite',
  'consignee_secondary_user': 'ConsigneeSecondaryUserDbWrite',
};

const exportAndRejectionHeaders = {
  'user': 'UsersMasterRejectionHeaders',
  'surge_threshold': 'SurgeThresholdRejectionHeaders',
  'vehicle_excludes': 'VehicleExcludesRejectionHeaders',
  'rate_matrix': 'RateMatrixRejectionHeaders',
  'detention': 'DetentionRejectionHeaders',
  'materialcategory': 'MaterialCategoryRejectionHeaders',
  'sla': 'SLAMasterRejectionHeaders',
  'share_of_business': 'ContractTsdMasterRejectionHeaders',
  'vehicle': 'VehicleRejectionHeaders',
  'consignee': 'ConsigneesRejectionHeaders',
  'consignee_additional_details': 'ConsigneesAdditionalDetailsRejectionHeaders',
  'transporter': 'TransporterMasterRejectionHeaders',
  depot: 'DepotMasterRejectionHeaders',
  gate: 'GateRejectionHeaders',
  material: 'MaterialMasterRejectionHeaders',
  associate_material: 'MaterialAssociateRejectionHeaders',
  extra_drop_off_charge: 'DropOffChargeRejectionHeaders',
  material_user_association: 'MaterialUserAssociateRejectionHeaders',
  loading: 'LoadingUnloadingRejectionHeaders',
  dedicatedtruck: 'DedicatedTruckRejectionHeaders',
  user_associate_material_upload: 'MaterialUserAssociateRejectionHeaders',
  driver: 'DriverRejectionHeaders',
  vehicledetail: 'VehicleDetailsRejectionHeaders',
  vehicle_availability: 'VehicleAvailabilityRejectionHeaders',
  source_charge: 'SourceChargeRejectionHeaders',
  purchase_order: 'PurchaseOrderRejectionHeaders',
  bucc: 'BuccRejectionHeaders',
  transit_management: 'TransitManagementRejectionHeaders',
  material_category_additional: 'MaterialCategoryAdditionalRejectionHeaders',
  redirection: 'RedirectionMasterRejectionHeaders',
  base_fuel_rate: 'BaseFuelRateMasterRejectionHeaders',
  freight_zone: 'FreightZoneMasterRejectionHeaders',
  legal_entity: 'LegalEntityMasterRejection',
  vehicle_eta: 'VehicleETARejectionHeaders',
  consignee_secondary_user: 'ConsigneeSecondaryUserRejection',
};

const validationClassMap = {
  'user': 'UserUploadValidator',
  rate_matrix: 'RateMatrixUploadValidator',
  'surge_threshold': 'SurgeThresholdValidator',
  'vehicle_excludes': 'VehicleExcludesValidator',
  'detention': 'DetentionUploadValidator',
  'materialcategory': 'MaterialCategoryValidator',
  'sla': 'SLAUploadValidator',
  'share_of_business': 'ContractTsdUploadValidator',
  'vehicle': 'VehicleUploadValidator',
  'consignee': 'ConsigneeUploadValidator',
  'consignee_additional_details': 'ConsigneeAdditionalDetailsValidator',
  'transporter': 'TransporterUploadValidator',
  'driver': 'DriverUploadValidator',
  transporter: 'TransporterUploadValidator',
  depot: 'DepotUploadValidator',
  gate: 'GateUploadValidator',
  material: 'MaterialUploadValidator',
  associate_material: 'MaterialAssociateUploadValidator',
  extra_drop_off_charge: 'DropOffChargeUploadValidator',
  material_user_association: 'MaterialUserAssociateUploadValidator',
  loading: 'LoadingUnloadingUploadValidator',
  dedicatedtruck: 'DedicatedTruckValidator',
  user_associate_material_upload: 'MaterialUserAssociateUploadValidator',
  vehicledetail: 'VehicleDetailsUploadValidator',
  vehicle_availability: 'VehicleAvailabilityUploadValidator',
  source_charge: 'SourceChargeUploadValidator',
  purchase_order: 'PurchaseOrderUploadValidator',
  bucc: 'BuccUploadValidator',
  transit_management: 'TransitManagementUploadValidator',
  material_category_additional: 'MaterialCategoryAdditionalValidator',
  redirection: 'RedirectionMasterUploadValidator',
  base_fuel_rate: 'BfrMasterUploadValidator',
  freight_zone: 'FreightZoneUploadValidator',
  legal_entity: 'LegalEntityUploadValidator',
  vehicle_eta: 'VehicleETAUploadValidator',
  consignee_secondary_user: 'ConsigneeSecondaryUserValidator',
};

const erpHeaderMappingFunctions = {
  'rate_matrix': 'erp_contract_header',
  'transporter': 'erp_transporter_header',
  'consignee': 'erp_consignee_header',
  'material': 'erp_material_header',
};

const ApprovalConstants = {
  ApprovalEventTypes: {
    RFQ: 1,
    OPEN: 2,
    RATE_MATRIX: 3,
    BASE_FUEL_RATE: 4,
    EPOD: 5,
    TRUCK_CHANGE_REQUEST: 6,
  },
  ApprovalFlows: {
    SEQUENTIAL: 1,
    PARALLEL: 2,
  },
  ThresholdBasedOn: {
    MATERIAL_INVOICE: 'invoice_amount',
    MRP: 'mrp',
  },
};

const ApprovalEvent = {
  1: 'RFQ',
  2: 'Base Freight',
  3: 'Rate Matrix',
  4: 'Base Fuel Rate',
  5: 'EPOD',
  6: 'Truck Change Request',
};

const epodApprovalStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
};

module.exports = {
  approvalStatus,
  approvalStatusText,
  mdmDetails,
  mdmUploadStatus,
  invalidCollectionTypesMapping,
  validDataClassMap,
  validationClassMap,
  erpHeaderMappingFunctions,
  updatedMdmDetails,
  exportAndRejectionHeaders,
  ApprovalConstants,
  ApprovalEvent,
  epodApprovalStatus,
};
